<script setup lang="ts">

</script>

<template>
  <div class="min-h-screen bg-white text-slate-900 dark:bg-slate-950 dark:text-slate-100">
    <!-- Top bar -->
    <LandingNav />

    <!-- Hero -->
    <LandingHeader id="header" />

    <!-- Manifest -->
    <LandingManifest id="manifesto" />

    <LandingAbout id="about" />

    <!-- Results/Stats -->
    <LandingResults id="risultati" />

    <!-- Packages -->
    <LandingPackage id="pacchetti" />

    <!-- Subscription -->
    <LandingSubscription id="subscription" />

    <!-- Testimonials
    <LandingTestimonials id="testimonianze" />
-->
    <LandingPosts id="blogs" />

    <!-- FAQ -->
    <LandingFaqs id="faq" />

    <!-- CTA -->
    <section class="border-t border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-950">
      <UContainer class="py-14 md:py-20">
        <div
          class="rounded-3xl border border-slate-200 bg-white p-8 dark:border-slate-800 dark:bg-slate-950 md:p-12"
        >
          <div class="flex flex-col justify-between gap-8 md:flex-row md:items-center">
            <div class="max-w-xl">
              <h3 class="text-2xl font-semibold text-slate-900 dark:text-white">
                Pronto a sbloccare il prossimo livello?
              </h3>
              <p class="mt-3 text-slate-600 dark:text-slate-300">
                Prenota una call conoscitiva: ti dico subito se e come posso aiutarti, in base ai tuoi obiettivi.
              </p>
            </div>
            <div class="flex flex-wrap gap-3">
              <UButton
                to="#pacchetti"
                variant="outline"
                size="lg"
                class="border-slate-200 text-slate-900 hover:bg-slate-50 dark:border-slate-800 dark:text-white dark:hover:bg-slate-900"
              >
                Vedi i pacchetti
              </UButton>
            </div>
          </div>
        </div>
      </UContainer>
    </section>

    <LandingContacts id="contacts" />

    <LandingFooter />
  </div>
</template>
